var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4D2053",
    d: "M74.597 112C100.777 112 122 98.62 122 82.115 122 65.611 117.265 38 91.085 38c-17.95 0-19.945 14.135-36.1 28.27-16.156 14.134-36.857 17.297-44.278 19.706C-62.733 109.81 48.417 112 74.597 112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82368C",
    d: "M78.389 127C100.266 127 118 110.908 118 91.058S114.043 38 92.167 38C77.167 38 75.5 55 62 72S25 89.46 25 95.7c0 19.85 31.512 31.3 53.389 31.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleWave);
export default __webpack_public_path__ + "static/media/purple-wave.8739c957899fe31f552901fabe0bd7f1.svg";
export { ForwardRef as ReactComponent };